import React, {useState} from 'react';
import {Formik, Field, Form} from 'formik';
import {TextField, Loading, CkEditor, Select, CheckBox, PersianDataPicker,GalleryField} from 'components/form';
import {required, validationWrapper} from 'lib/formValidations';
import {dateTimeToserver, generate_uuid, transformTranslateFromValues} from 'lib/helpers';
import Modal from 'components/Modal'
import {useCore} from 'store/core'
// components

export default function Add(props) {
   const [prices, setPrices] = useState([]);
   const [showAddPrice, setShowAddPrice] = useState(false);
   const core = useCore();

   const _renderPrices = () => {
      return prices.map((item) => (
         <div className="grid grid-cols-4 gap-2">
            <h5>{item.currency === "USD" ? "دلار" : "تومان"}</h5>
            <h5 className="text-center">{item.amount}</h5>
            <h5 className="text-center">
               <button
                  type="button"
                  className={`btn btn-sm ${item.status ? "btn-success" : "btn-danger"}`}
                  onClick={() => {
                     setPrices([...prices.filter(i => (i.uuid !== item.uuid)), {...item, status: !item.status}])
                  }}>
                  {item.status ? "فعال" : "غیر فعال"}
               </button>
            </h5>
            <div className="flex justify-center items-center">
               <button
                  type="button"
                  onClick={() => {
                     setPrices(prices.filter((i) => i.uuid != item.uuid));
                  }}
                  className="btn btn-sm btn-danger"
               >
                  حذف
               </button>
            </div>
         </div>
      ));
   };


   return (
      <>
         <AddPrices
            close={() => setShowAddPrice(false)}
            show={showAddPrice}
            submit={(values) => {
               setPrices([...prices, values]);
            }}
         />
         <Modal show={props.show} handleClose={props.close} title={props.title}>
            <Formik
               initialValues={{}}
               onSubmit={async (values, {setSubmitting}) => {
                  if (values.published_from) {
                     values.published_from = dateTimeToserver(values.published_from)
                  }
                  if (values.published_to) {
                     values.published_to = dateTimeToserver(values.published_to)
                  }
                  await props.submit({...transformTranslateFromValues(values), prices});
                  props.close();
                  setSubmitting(false);
               }}
               enableReinitialize
            >
               {({isSubmitting, dirty}) => (
                  <Form>
                     <div className="modal-body py-1 gap-y-3">
                        <div className="intro-x md:grid md:grid-cols-2 md:gap-3">
                           <Field
                              placeholder="عنوان"
                              label="عنوان :"
                              name="title"
                              component={TextField}
                              validate={(value) => validationWrapper(value, required)}
                           />
                           <Field
                              placeholder="عنوان انگلیسی"
                              label="عنوان انگلیسی :"
                              name="_en*title*text"
                              component={TextField}
                           />
                           <div className="col-span-2 md:grid md:grid-cols-3 md:gap-3">
                              <div>
                                 {core.slidersLoad ? <Loading/> :
                                    <Field
                                       label="اسلایدر :"
                                       name="slider_id"
                                       valueOnly
                                       component={Select}
                                       options={core.sliders || []}
                                    />
                                 }
                              </div>
                              <Field
                                 label="انتشار از :"
                                 name="published_from"
                                 component={PersianDataPicker}
                                 format="YYYY/MM/DD HH:mm:ss"
                                 hasTime={true}
                                 validate={(value) => validationWrapper(value, required)}
                              />
                              <Field
                                 label="انتشار تا :"
                                 name="published_to"
                                 component={PersianDataPicker}
                                 format="YYYY/MM/DD HH:mm:ss"
                                 hasTime={true}
                                 validate={(value) => validationWrapper(value, required)}
                              />
                           </div>
                           <div className="intro-y col-span-2 border rounded p-2 border-theme-21">
                              <div className="flex justify-between items-center">
                                 <h2>قیمت ها :</h2>
                                 <button
                                    type="button"
                                    className="btn btn-sm btn-primary"
                                    onClick={() => setShowAddPrice(true)}
                                 >
                                    افزودن قیمت
                                 </button>
                              </div>
                              <hr className="my-2"/>
                              <div className="grid grid-cols-1 gap-4 mt-3">
                                 <div className="grid grid-cols-4 gap-2">
                                    <h5>واحد پولی</h5>
                                    <h5 className="text-center">مقدار</h5>
                                    <h5 className="text-center">وضعیت</h5>
                                    <div className="flex justify-center items-center">
                                       عملیات
                                    </div>
                                 </div>
                                 {_renderPrices()}
                              </div>
                           </div>
                           <Field
                              label="توضیحات کوتاه"
                              name="short_desc"
                              component={CkEditor}
                           />
                           <Field
                              label="توضیحات کوتاه انگلیسی"
                              name="_en*short_desc*text"
                              component={CkEditor}
                           />
                           <Field
                              label="توضیحات کامل"
                              name="full_desc"
                              component={CkEditor}
                           />
                           <Field
                              label="توضیحات کامل انگلیسی"
                              name="_en*full_desc*text"
                              component={CkEditor}
                           />
                        </div>
                        <div className="w-full flex justify-between">
                  <div className="w-5/12">
                    <Field
                      label="تصویر"
                      name="media_id"
                      dataType="id"
                      component={GalleryField}
                    />
                  </div>
                  <div className="w-5/12">
                    <Field
                      label="Image"
                      name="_en*media_id*media"
                      dataType="id"
                      component={GalleryField}
                    />
                  </div>
                </div>
                     </div>
                     <div className="modal-footer text-right">
                        <button className="btn btn-primary w-20" type="submit"
                                disabled={!!(isSubmitting || !dirty)}> {isSubmitting ?
                           <Loading/> : 'ذخیره'}</button>
                        <button type="button"
                                disabled={isSubmitting}
                                onClick={props.close} className="btn btn-outline-secondary w-20 mr-1">انصراف
                        </button>
                     </div>
                  </Form>
               )}
            </Formik>

         </Modal>
      </>
   );
}


export function AddPrices(props) {
   return (
      <Modal
         zIndex={1000}
         show={props.show}
         handleClose={props.close}
         title="افزودن قیمت"
      >
         <Formik
            key="fromik_p_price"
            initialValues={{uuid: generate_uuid()}}
            onSubmit={(values, {setSubmitting}) => {
               props.submit(values);
               props.close();
               setSubmitting(false);
            }}
         >
            {({isSubmitting, dirty, handleSubmit}) => (
               <Form>
                  <div className="modal-body gap-y-3">
                     <div className="intro-x grid md:grid-cols-4 md:gap-3">
                        <div></div>
                        <div className="">
                           <Field
                              placeholder="واحد پولی"
                              label="واحد پولی :"
                              name="currency"
                              component={Select}
                              options={[
                                 {value: "IRR", label: "تومان"},
                                 {value: "USD", label: "دلار"},
                              ]}
                              validate={(value) => validationWrapper(value, required)}
                           />
                        </div>
                        <div className="">
                           <Field
                              placeholder="مقدار"
                              label="مقدار :"
                              name="amount"
                              component={TextField}
                              validate={(value) => validationWrapper(value, required)}
                           />
                        </div>
                        <div className="">
                           <Field
                              label="فعال؟"
                              name="status"
                              component={CheckBox}
                           />
                        </div>
                     </div>
                  </div>
                  <div className="modal-footer text-right">
                     <button
                        className="btn btn-primary w-20"
                        type="button"
                        onClick={handleSubmit}
                        disabled={!!(isSubmitting || !dirty)}
                     >
                        {isSubmitting ? <Loading/> : "ذخیره"}
                     </button>
                     <button
                        type="button"
                        disabled={isSubmitting}
                        onClick={props.close}
                        className="btn btn-outline-secondary w-20 mr-1"
                     >
                        انصراف
                     </button>
                  </div>
               </Form>
            )}
         </Formik>
      </Modal>
   );
}
